import React, { forwardRef, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import TariffList from '../TariffList/TariffList'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import AuthSelectors from 'Stores/Auth/Selectors'

const TariffModalContainer = forwardRef(
  (
    {
      isEditing,
      tariffsList,
      maxListHeight,
      scrollbarsHeight,
      onModalSubmit = () => {},
      removeExtraMargin,
      fetchTariffsList,
      operator,
    },
    ref,
  ) => {
    const onSubmit = (addTariffs, deleteTariffs) => {
      onModalSubmit(addTariffs)
    }
    const defaultTariffsList = tariffsList
      .filter((tarr) => {
        return tarr.isDefault === true
      })
      .map((tarr) => {
        return {
          tariff: {
            ...tarr,
          },
          expiryDate: tarr.expiresAt,
          consumedPower: tarr.consumedPower,
        }
      })

    useEffect(() => {
      fetchTariffsList()
    }, [])

    return (
      <div style={{ height: '100%' }}>
        <TariffList
          ref={ref}
          displayedList={defaultTariffsList}
          dropdownList={tariffsList}
          isEditing={isEditing}
          isLoading={false}
          maxListHeight={maxListHeight}
          scrollbarsHeight={scrollbarsHeight}
          onSubmit={onSubmit}
          removeExtraMargin={removeExtraMargin}
          country={operator.country}
        />
      </div>
    )
  },
)
function mapDispatchToProps(dispatch) {
  return {
    fetchTariffsList: () => dispatch(OperatorUserActions.fetchTariffsList()),
  }
}

const mapStateToProps = (state) => ({
  tariffsList: OperatorUserSelectors.getTariffsList(state),
  operator: AuthSelectors.getOperator(state),
})

TariffModalContainer.propTypes = {
  isEditing: PropTypes.bool,
  tariffsList: PropTypes.array,
  tariffsListRef: PropTypes.object,
  maxListHeight: PropTypes.any,
  scrollbarsHeight: PropTypes.any,
  onModalSubmit: PropTypes.func,
  fetchTariffsList: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(TariffModalContainer)
